import React, { useMemo } from 'react'
import { Form, DatePicker as DatePickerAntd } from 'antd'
import moment from 'moment'
import dp from 'dot-prop-immutable'

import { useT } from 'src/core/hooks/use-translation'
import i18n from 'src/config/i18n'
import { DatePickerProps } from 'antd/lib/date-picker/interface'
import { FormItemProps } from 'antd/lib/form'

import pt_BR from 'antd/lib/date-picker/locale/pt_BR'
import es_ES from 'antd/lib/date-picker/locale/es_ES'
import en_US from 'antd/lib/date-picker/locale/en_US'

type Props = DatePickerProps &
  FormItemProps & {
    formikProps: any
  }

function DatePicker({
  formikProps,
  label,
  name,
  onChange,
  placeholder,
  style,
  required = true,
  size = 'large',
  ...props
}: Props) {
  const { t } = useT()
  const locale = ['pt', 'pt_br', 'pt-br'].includes(
    i18n.language.toLocaleLowerCase()
  )
    ? pt_BR
    : ['es', 'es_es', 'es-es'].includes(i18n.language.toLocaleLowerCase())
    ? es_ES
    : en_US

  const error = useMemo(() => {
    return dp.get(formikProps.errors, name)
  }, [formikProps.errors, name])

  const touched = useMemo(() => {
    return dp.get(formikProps.touched, name)
  }, [formikProps.touched, name])

  const value = useMemo(() => {
    return dp.get(formikProps.values, name)
  }, [formikProps.values, name])

  return (
    <Form.Item
      colon={false}
      hasFeedback
      help={touched ? t(error) : ''}
      label={t(label)}
      required={required}
      validateStatus={
        error && touched ? 'error' : !error && touched ? 'success' : ''
      }
    >
      <DatePickerAntd
        {...props}
        data-test-id="date-picker"
        allowClear={false}
        style={style}
        format="DD/MM/YYYY"
        locale={locale}
        onChange={value => {
          onChange && onChange(value, undefined)
          formikProps.setFieldValue(
            name,
            value
              ? value.hours(0).minutes(0).seconds(0).millisecond(0).unix()
              : undefined
          )
        }}
        onOpenChange={() =>
          formikProps.setTouched({ ...formikProps.touched, [name]: true })
        }
        placeholder={t(placeholder)}
        size={size}
        value={value ? moment.unix(value) : undefined}
      />
    </Form.Item>
  )
}

export default DatePicker
